export default __webpack_public_path__ + "static/hero_home_img_9-490297ac5c4281812adaad2614fd23b4.png";